module.exports = __webpack_public_path__ + "static/media/HomeStoryImage3.d1c77dbb.jpg";